import React from 'react'

import pins from './pinsV2'
import type { PinSizing } from './pinsV2'
import config from 'constants/config'
import { OFFER_TYPE_BED_BANK, OFFER_TYPE_HOTEL } from 'constants/offer'
import styled from 'styled-components'

function scaleDownSizing(sizing: PinSizing): PinSizing {
  const SCALE = 5 / 6
  const { size, anchor } = sizing
  return {
    size: [size[0] * SCALE, size[1] * SCALE],
    anchor: [anchor[0] * SCALE, anchor[1] * SCALE],
  }
}

const MarkerContainer = styled.div`
  filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
`

interface Props {
  active: boolean;
  visited: boolean;
  soldOut: boolean;
  marker: App.MapMarkerV2;
  scaleDown?: boolean;
  isHovered?: boolean;
}

function PropertyMarker(props: React.PropsWithChildren<Props>) {
  const {
    active,
    visited,
    soldOut,
    marker,
    scaleDown,
    isHovered,
  } = props

  const isAllBedbank = marker.offers.every(offer => offer.type === OFFER_TYPE_BED_BANK)

  const isAllFlash = marker.offers.every(offer => offer.type === OFFER_TYPE_HOTEL)

  const brandPinConfig = pins[config.BRAND] ?? pins.default

  let pinIcons = brandPinConfig.pinIcons
  if (soldOut) {
    pinIcons = brandPinConfig.soldOutPinIcons
  } else if (isAllBedbank) {
    pinIcons = brandPinConfig.bedbankPinIcons
  } else if (isAllFlash) {
    pinIcons = brandPinConfig.flashPinIcons
  }

  let pinVersion = pinIcons.default
  if (active || isHovered) {
    pinVersion = pinIcons.active
  } else if (visited) {
    pinVersion = pinIcons.previewed
  }

  const pin = (isHovered && !active) ? pinVersion.hover : pinVersion.default
  const { image, sizing: fullSizing } = pin

  const sizing = scaleDown ? scaleDownSizing(fullSizing) : fullSizing

  const [width, height] = sizing.size

  return (
    <MarkerContainer>
      <img src={image} width={width} height={height} style={{ position: 'absolute', left: -sizing.anchor[0], top: -sizing.anchor[1] }} alt=""/>
    </MarkerContainer>
  )
}

export default React.memo(PropertyMarker)
